import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    sourceCount: 0,
    amount: 0,
    dingCount: 0,
    followerCount: 0,
    followingCount: 0,
    province: "",
    city: "",
    district: "",
    street: "",
    birthday: "",
    profession: "",
    gender: "",
    sign: "",
    bgImg: "",
    cert: "",
    nickname: "",
    avatar: "",
    daily: "",
    goto: "",
    height: "",
    memory: "",
    tobe: "",
    wish: "",
  },
  mutations: {
    SET_SOURCECOUNT(state, data) {
      state.sourceCount = data;
    },
    SET_AMOUNT(state, data) {
      state.amount = data;
    },
    SET_DINGCOUNT(state, data) {
      state.dingCount = data;
    },
    SET_FOLLOWERCOUNT(state, data) {
      state.followerCount = data;
    },
    SET_FOLLOWINGCOUNT(state, data) {
      state.followingCount = data;
    },
    SET_PROVINCE(state, data) {
      state.province = data;
    },
    SET_CITY(state, data) {
      state.city = data;
    },
    SET_DISTRICT(state, data) {
      state.district = data;
    },
    SET_BIRTHDAY(state, data) {
      state.birthday = data;
    },
    SET_STREET(state, data) {
      state.street = data;
    },
    SET_PROFESSION(state, data) {
      state.profession = data;
    },
    SET_GENDER(state, data) {
      state.gender = data;
    },
    SET_SIGN(state, data) {
      state.sign = data;
    },
    SET_CERT(state, data) {
      state.cert = data;
    },
    SET_BGIMG(state, data) {
      state.bgImg = data;
    },
    SET_NICKNAME(state, data) {
      state.nickname = data;
    },
    SET_AVATAR(state, data) {
      state.avatar = data;
    },
    SET_DAILY(state, data) {
      state.daily = data;
    },
    SET_GOTO(state, data) {
      state.goto = data;
    },
    SET_HEIGHT(state, data) {
      state.height = data;
    },
    SET_MEMOTY(state, data) {
      state.memory = data;
    },
    SET_TOBE(state, data) {
      state.tobe = data;
    },
    SET_WISH(state, data) {
      state.wish = data;
    }
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/pages/store.js